module.exports = __webpack_public_path__ + "img/dyk.557f7c54.svg";